import { heroData } from '@/mocks/homepage';

export default function Hero() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100/60 via-transparent to-background-50 pointer-events-none"></div>

      <div className="relative w-full px-4 md:px-6 py-24 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block text-sm font-medium text-primary-500 bg-primary-50 px-4 py-1.5 rounded-full mb-5 whitespace-nowrap">
              {heroData.tag}
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-4">
              {heroData.h1}
            </h1>

            <p className="text-lg md:text-xl text-primary-500 font-heading mb-6">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {heroData.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {heroData.stats.map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading text-primary-500">{stat.value}</div>
                  <div className="text-xs text-foreground-600 mt-1">{stat.label}</div>
                  <div className="text-xs text-foreground-400">{stat.desc}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                onClick={(e) => { e.preventDefault(); handleClick(heroData.primaryCta.href); }}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {heroData.primaryCta.text}
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </a>
              <a
                href={heroData.secondaryCta.href}
                onClick={(e) => { e.preventDefault(); handleClick(heroData.secondaryCta.href); }}
                className="inline-flex items-center gap-2 px-8 py-3 border border-foreground-300 text-foreground-700 rounded-full text-sm font-medium hover:border-primary-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {heroData.secondaryCta.text}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cozy%20bedroom%20at%20night%20with%20soft%20warm%20amber%20fairy%20lights%20draped%20across%20the%20wall%2C%20a%20laptop%20screen%20glowing%20softly%20on%20the%20bed%20showing%20a%20serene%20movie%20scene%2C%20gentle%20moonlight%20streaming%20through%20a%20window%20with%20sheer%20curtains%2C%20cherry%20blossom%20branches%20visible%20outside%20the%20window%20in%20spring%20night%2C%20a%20steaming%20cup%20of%20tea%20on%20the%20nightstand%2C%20peaceful%20and%20atmospheric%20night%20viewing%20experience%2C%20cinematic%20mood%20with%20soft%20shadows%20and%20warm%20golden%20tones%2C%20digital%20illustration%20style%20with%20dreamy%20quality%20and%20painterly%20textures&width=800&height=600&seq=hero-main&orientation=landscape"
                alt="春夜影院 - 夜晚观影氛围"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>

              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                <div className="flex items-center gap-1 bg-background-50/90 backdrop-blur-sm rounded-full px-4 py-2">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-play-circle-fill text-accent-500 text-lg"></i>
                  </span>
                  <span className="text-xs text-foreground-700 whitespace-nowrap">正在播放：春日治愈特辑</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}